import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

export const FrequencyWaves: React.FC<{ opacity?: number }> = ({ opacity = 1 }) => {
  const frame = useCurrentFrame();

  const waveCount = 3;
  const pointsPerWave = 60;

  return (
    <AbsoluteFill style={{ opacity, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg viewBox="0 0 1080 1920" width="100%" height="100%" style={{ position: "absolute" }}>
        {Array.from({ length: waveCount }, (_, wi) => {
          const yCenter = 960 + (wi - 1) * 200;
          const amplitude = 30 + wi * 15;
          const frequency = 0.015 + wi * 0.005;
          const speed = 0.03 + wi * 0.01;
          const waveOpacity = 0.08 - wi * 0.02;

          const points = Array.from({ length: pointsPerWave }, (_, pi) => {
            const x = (pi / (pointsPerWave - 1)) * 1080;
            const y = yCenter + Math.sin(pi * frequency * 10 + frame * speed) * amplitude
              * (1 + Math.sin(frame * 0.02 + wi) * 0.3);
            return `${x},${y}`;
          }).join(" ");

          return (
            <polyline key={wi}
              points={points}
              fill="none"
              stroke={wi === 0 ? "#F37021" : "#D4A843"}
              strokeWidth={1.5}
              opacity={waveOpacity + Math.sin(frame * 0.02 + wi * 2) * 0.02}
            />
          );
        })}
      </svg>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
